<!-- HTML -->
<template>
  <div id="app">
    <NavMenu />
    <transition
      name="fade-r"
      mode="out-in"
    >
      <router-view/>
    </transition>
    <Modal />
  </div>
</template>

<!-- JavaScript -->
<script>
import NavMenu from "@/components/navmenu/NavMenu.vue";
import Modal from "@/components/modal/Modal.vue";
export default {
  name: "App",
  components: {
    NavMenu,
    Modal
  }
};
</script>

<!-- CSS -->
<style lang="scss">
@import "./assets/scss/fonts.scss"; // Available globally
@import "./assets/scss/variables.scss";
@import "./assets/scss/transitions.scss";
</style>
